module.exports = __webpack_public_path__ + "img/gettyimages.5044b46b.jpg";